import { Stack } from 'components'
import { useArcTranslation } from 'hooks'
import { ManagerGreeting } from './components/ManagerGreeting'
import { NavigationCards } from './components/NavigationCards'
import { LatestProjectsSection } from './components/LatestProjectsSection'
import { LatestClassesSection } from './components/LatestClassesSection'
import { SectionErrorBoundary } from './components/SectionErrorBoundary'

/** Stacks the dashboard sections; each one is isolated by its own error boundary. */
export const ManagerDashboardContent = () => {
  const { t } = useArcTranslation()
  const sectionError = t('manager_dashboard.section_error')

  return (
    <Stack spacing='xl' p='md'>
      <SectionErrorBoundary fallbackMessage={sectionError}>
        <ManagerGreeting />
      </SectionErrorBoundary>

      <SectionErrorBoundary fallbackMessage={sectionError}>
        <NavigationCards />
      </SectionErrorBoundary>

      <SectionErrorBoundary fallbackMessage={sectionError}>
        <LatestProjectsSection />
      </SectionErrorBoundary>

      <SectionErrorBoundary fallbackMessage={sectionError}>
        <LatestClassesSection />
      </SectionErrorBoundary>
    </Stack>
  )
}
